import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { UpdateProfileImage } from "../../service/apis/auth.api";
import { setUser } from "../../store/auth.store";
import PersonalInfoScreen from "../../component/personal-info";
import ResidentialDetailsScreen from "../../component/residential-detial";
import EducationalDetailsScreen from "../../component/educational-info";
import WorkExpDetailsScreen from "../../component/work-experience-info";
import SkillDetailsScreen from "../../component/skill-info";
import UserProfileNoImg from "@/../../public/images/no-image.jpg";
import { showSuccess } from "../../utils/Common";

const ProfileAccountDetailsScreen = () => {
  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);

  const { user } = useSelector((state: RootState) => state.authSlice);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFile(file);
      //   setCompanyLogo(file);
      const reader = new FileReader();
      reader.onload = () => setSelectedImage(reader.result as string);
      reader.readAsDataURL(file);
    }
  };

  const handleImageUpload = async () => {
    if (file) {
      // Logic to upload the file to the server

      const formData = new FormData();
      formData.append("profileimageurl", file);
      const response = await UpdateProfileImage(formData);
      dispatch(setUser(response.user));
      showSuccess("Profile Image Updated successfully");
      setFile(null);
    }
  };

  // Inside your component
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically trigger the input click
    }
  };
  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                <SidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <TopHeadScreen />
                <div className="profile-account-details-holder rightInnerScroll common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Account</h2>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="comnbrdrGap  profile-image">
                              <div className="profile-image-img">
                                <img
                                  src={
                                    selectedImage ||
                                    user?.profileimageurl ||
                                    UserProfileNoImg
                                  }
                                  alt="profile"
                                />
                              </div>
                              <h4>
                                {user?.externalInfo?.name}{" "}
                                <span>Jobseeker</span>
                              </h4>
                              <input
                                type="file"
                                accept="image/*"
                                name="companyLogo"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                ref={fileInputRef}
                              />
                              {!file && (
                                <Button onClick={handleImageClick}>
                                  Change Image
                                </Button>
                              )}
                              {file && (
                                <Button onClick={handleImageUpload}>
                                  Upload Image
                                </Button>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-9">
                            <PersonalInfoScreen />
                            <ResidentialDetailsScreen />
                            <EducationalDetailsScreen />
                            <WorkExpDetailsScreen />
                            <SkillDetailsScreen />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default ProfileAccountDetailsScreen;
